import React, { useState } from 'react'
import '../../styles/Whatsapp.css'

function Whatsapp() {

    const [showMenu, setShowMenu] = useState(false);

    const togglebutton = () => {
        setShowMenu(!showMenu);
    };
    return (
        <div className='Whatsapp'>
            <img src="img/whatsapp-icon.png"onClick={togglebutton} alt="whatsapp icon" />
            <div className={showMenu?'menu-window active':'menu-window'}>
                <ul>
                    <li>
                        <a href="#" target="_blank" rel="noopener noreferrer">Bahrain number</a>

                    </li>
                    <li>
                        <a href="https://wa.me/+97337574555" target="_blank" rel="noopener noreferrer">India number</a>

                    </li>
                </ul>
            </div>
        </div>
    )
}

export default Whatsapp